import React from "react";
import {TextValidator} from "react-material-ui-form-validator";
import localization from '../../../config/localization';
import TranslatableInputs from "../../../components/Letflow/TranslatableInputs";
import {FormControl, FormControlLabel} from "@material-ui/core";
import AsyncSelect from "react-select/lib/Async";
import {Radio, RadioGroup} from "@material-ui/core/index";

class FormView extends React.Component {

  findMissingFields = () => this.child.findMissingFields()

  render = () => {
    const {
      disabled,
      nameEs,
      nameEn,
      namePt,
      order,
      types,
      groupType,
      onChange,
      onTypeChange,
      selectedTypes,
      isGlobal,
      isEditorial,
      brandType,
      creating,
      isTalent
    } = this.props

    return (
      <div>
        {!isEditorial &&
          <div>
            <span>{localization.get("tag_groups.group")}</span>
            <RadioGroup
              id="groupType"
              value={groupType}
              onChange={e => {
                e.target.id = "groupType";
                onChange(e)
              }}
              style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
            >
              <FormControlLabel value="content" control={<Radio color="default"/>}
                                label={localization.get('tag_groups.type.content')}/>
              <FormControlLabel value="material" control={<Radio color="default"/>}
                                label={localization.get('tag_groups.type.material')}/>
            </RadioGroup>
          </div>
        }

        <div>
          <RadioGroup
            id="isGlobal"
            value={isGlobal}
            onChange={e => {
              e.target.id = "isGlobal";
              onChange(e)
            }}
            style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
          >
            <FormControlLabel value="isGlobal" control={<Radio color="default"/>} label={localization.get('tag_groups.is_global')}/>
            <FormControlLabel value="notGlobal" control={<Radio color="default"/>} label={localization.get('tag_groups.not_global')}/>
            {isTalent && groupType === "content" && <FormControlLabel value="bloomclouds" control={<Radio color="default"/>} label="Creators"/>}
            {isTalent && groupType === "content" && <FormControlLabel value="bigCreator" control={<Radio color="default"/>} label={"Big Creators"}/>}
          </RadioGroup>
        </div>
        {isGlobal === "notGlobal" &&
          <FormControl fullWidth>
            <span>{localization.get('form.select_content_creator_type')}</span>
            <AsyncSelect
              styles={{
                menu: base => ({
                  ...base,
                  zIndex: 10
                })
              }}
              theme={theme => ({
                ...theme,
                borderRadius: 0
              })}
              placeholder={localization.get('content_creator_types')}
              loadingMessage={() => localization.get('loading')}
              noOptionsMessage={() => localization.get('no_options')}
              onChange={onTypeChange}
              validators={['required']}
              errorMessages={[localization.get('validator.is_required')]}
              isMulti={groupType !== 'both'}
              value={selectedTypes}
              loadOptions={(inputValue, callback) => {
                callback(types.filter(i =>
                  i.label.toLowerCase().includes(inputValue.toLowerCase())
                ))
              }}
              defaultOptions={types}
            />
          </FormControl>
        }
        <TextValidator
          style={{ width: "100%" }}
          id="order"
          label={localization.get('form.order')}
          name="order"
          value={order}
          onChange={onChange}
          disabled={disabled}
          validators={['isNumber']}
          errorMessages={[localization.get('validator.is_number')]}
        />

        <TranslatableInputs
          ref={instance => this.child = instance}
          children={[
            {
              language: 'es',
              content: [
                <TextValidator
                  style={{width: "100%"}}
                  id="nameEs"
                  label={localization.get('form.name')}
                  name="nameEs"
                  value={nameEs}
                  onChange={onChange}
                  disabled={disabled}
                  validators={['required']}
                  errorMessages={[localization.get('validator.is_required')]}
                />
              ]
            },
            {
              language: 'en',
              content: [
                <TextValidator
                  style={{width: "100%"}}
                  id="nameEn"
                  label={localization.get('form.name')}
                  name="nameEn"
                  value={nameEn}
                  onChange={onChange}
                  disabled={disabled}
                  validators={['required']}
                  errorMessages={[localization.get('validator.is_required')]}
                />
              ]
            },
            {
              language: 'pt',
              content: [
                <TextValidator
                  style={{width: "100%"}}
                  id="namePt"
                  label={localization.get('form.name')}
                  name="namePt"
                  value={namePt}
                  onChange={onChange}
                  disabled={disabled}
                  validators={['required']}
                  errorMessages={[localization.get('validator.is_required')]}
                />
              ]
            },
          ]}
        />
      </div>
    )
  }
}

export default FormView
